import { render, staticRenderFns } from "./PopupHeader.vue?vue&type=template&id=65481aee&scoped=true&"
import script from "./PopupHeader.vue?vue&type=script&lang=ts&"
export * from "./PopupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PopupHeader.vue?vue&type=style&index=0&id=65481aee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65481aee",
  null
  
)

export default component.exports